import get from 'lodash/get';
import { Assets, uploadAssetActions } from 'modules/assets';
import { resolveErrorMessage } from 'modules/errors';
import { postAudioClip } from './api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// S3 upload
function uploadAudioClip(auditionId, applicationId, messageId, file) {
  const context = Assets.createAuditionMessageContext(
    auditionId,
    applicationId,
    messageId,
  );

  return uploadAssetActions(file, 'audio', 'auditionAudioClip', context);
}

function postClip(auditionId, applicationId, messageId, values) {
  const file = get(values, 'file');

  if (!file) {
    return Promise.resolve();
  }

  // S3 upload, returns finalAssetPath
  return uploadAudioClip(auditionId, applicationId, messageId, file).then(
    assetPath => {
      const title = get(values, 'details.name');
      const clip = { title, url: assetPath };

      return postAudioClip(auditionId, applicationId, messageId, clip); // DB posting
    },
  );
}

export const createAudioClip = createAsyncThunk(
  'audioClips/create',
  async ({ auditionId, applicationId, messageId, values }) =>
    await postClip(auditionId, applicationId, messageId, values),
);

const audioClipSlice = createSlice({
  name: 'audioClips',
  initialState: {
    clips: {},
    loading: false,
    submitError: null,
  },
  extraReducers: builder => {
    builder
      .addCase(createAudioClip.fulfilled, (state, action) => {
        const auditionId = action.payload.meta;
        const newAudio = action.payload.data;

        if (state.clips[auditionId]) {
          state.clips[auditionId] = [newAudio, ...state.clips[auditionId]];
        } else {
          state.clips[auditionId] = [newAudio];
        }
        state.submitError = false;
      })
      .addCase(createAudioClip.rejected, (state, action) => {
        state.submitError = resolveErrorMessage(action.error);
      });
  },
  selectors: {
    getSubmitError: state => state.submitError,
  },
});

export const reducer = audioClipSlice.reducer;
export const { getSubmitError } = audioClipSlice.selectors;
